import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getSettingsPortalUserSearch = get(
  'settings.components.portal.userSearch'
);

export const getSettingsPortalUserSearchQuery = createSelector(
  getSettingsPortalUserSearch,
  get('query')
);
